import { render } from "./home.vue?vue&type=template&id=11cf2a5f&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"

import "./home.vue?vue&type=style&index=0&id=11cf2a5f&scoped=true&lang=css"

import exportComponent from "/Users/mathieu/conductor/workspaces/miakapp-v3/lima-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11cf2a5f"]])

export default __exports__